module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-md"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n    A GRV precisa já ter uma retirada cadastrada — esta automação não cria retiradas novas, só corrige os dados\n    de quem retirou. Limite de 5MB e 2000 linhas por envio.\n  ")]), _vm._v(" "), (!_vm.resultado) ? _c('div', {
    staticClass: "checkbox m-b"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosPrimeiraLinha),
      expression: "dadosPrimeiraLinha"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.loading
    },
    domProps: {
      "checked": Array.isArray(_vm.dadosPrimeiraLinha) ? _vm._i(_vm.dadosPrimeiraLinha, null) > -1 : (_vm.dadosPrimeiraLinha)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dadosPrimeiraLinha,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.dadosPrimeiraLinha = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.dadosPrimeiraLinha = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.dadosPrimeiraLinha = $$c
        }
      }
    }
  }), _vm._v("\n      É o mesmo arrematante em toda a planilha — usar os dados da "), _c('strong', [_vm._v("primeira linha")]), _vm._v(" em todas as GRVs\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.arquivo) ? _c('div', {
    staticClass: "m-b"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.escolherArquivo
    }
  }, [_c('i', {
    staticClass: "fa fa-upload m-r-xs"
  }), _vm._v(" Selecionar planilha\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputArquivo",
    attrs: {
      "type": "file",
      "accept": ".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _c('div', {
    staticClass: "m-b"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-file-excel-o m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.arquivo.name))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-link",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.trocarArquivo
    }
  }, [_vm._v("\n      (trocar arquivo)\n    ")]), _vm._v(" "), (!_vm.resultado) ? _c('div', {
    staticClass: "m-t-sm"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.analisar
    }
  }, [_c('i', {
    staticClass: "fa fa-search m-r-xs"
  }), _vm._v(" Analisar planilha (pré-visualização)\n      ")])]) : _vm._e()]), _vm._v(" "), (_vm.resultado) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: _vm.temResultadoAplicado ? 'alert-success' : 'alert-info'
  }, [_c('strong', [_vm._v(_vm._s(_vm.temResultadoAplicado ? 'Alterações aplicadas.' : 'Pré-visualização (nada foi gravado ainda).'))]), _vm._v(" "), _c('br'), _vm._v("\n      Total de linhas: " + _vm._s(_vm.resultado.totalLinhas) + " —\n      "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.resultado.totalAtualizadas) + " para atualizar")]), _vm._v(" —\n      "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.resultado.totalErros) + " com erro")])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "max-height": "45vh",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-striped table-condensed b-t b-light"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado.linhas), function(linha) {
    return _c('tr', {
      key: linha.linha
    }, [_c('td', [_vm._v(_vm._s(linha.linha))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linha.numero))]), _vm._v(" "), _c('td', {
      class: _vm.corStatus(linha.status)
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.iconeStatus(linha.status)
    }), _vm._v(" " + _vm._s(linha.status) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linha.mensagem))])])
  }), 0)])]), _vm._v(" "), (_vm.temPreview) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.podeConfirmar || _vm.loading
    },
    on: {
      "click": _vm.confirmar
    }
  }, [_c('i', {
    staticClass: "fa fa-check m-r-xs"
  }), _vm._v(" Confirmar e aplicar " + _vm._s(_vm.resultado.totalAtualizadas) + " alteração(ões)\n      ")]), _vm._v(" "), (!_vm.podeConfirmar) ? _c('span', {
    staticClass: "text-muted m-l-sm"
  }, [_vm._v("Nenhuma linha válida para aplicar.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.temResultadoAplicado) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Fechar")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n    Envie uma planilha (.xlsx ou .xls) para corrigir o "), _c('strong', [_vm._v("nome")]), _vm._v(", "), _c('strong', [_vm._v("tipo/número de documento")]), _vm._v(",\n    "), _c('strong', [_vm._v("CEP")]), _vm._v(" e "), _c('strong', [_vm._v("endereço")]), _vm._v(" já cadastrados na retirada de várias GRVs de uma só vez.\n    A planilha deve ter uma linha de cabeçalho com as colunas:\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "text-muted"
  }, [_c('li', [_c('strong', [_vm._v("GRV")]), _vm._v(" (ou "), _c('strong', [_vm._v("numero")]), _vm._v(") — obrigatória, número da GRV")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("NOME")]), _vm._v(" — nome de quem retirou/arrematou")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("TIPO DOCUMENTO")]), _vm._v(" — CPF ou CNPJ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("NUMERO DOCUMENTO")]), _vm._v(" — número do CPF/CNPJ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("CEP")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Endereço")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Linha")]), _vm._v(" "), _c('th', [_vm._v("GRV")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Mensagem")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c57e6ae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/automacoes/components/RetiradaEmMassa.vue
// module id = 1678
// module chunks = 18